import { render, staticRenderFns } from "./NotarProduct.vue?vue&type=template&id=5dd5156f&scoped=true"
import script from "./NotarProduct.vue?vue&type=script&lang=js"
export * from "./NotarProduct.vue?vue&type=script&lang=js"
import style0 from "./NotarProduct.vue?vue&type=style&index=0&id=5dd5156f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd5156f",
  null
  
)

export default component.exports